<script lang="ts" setup>
import TheHeaderDesktop from '@/components/Header/TheHeaderDesktop.vue'
import TheHeaderMobile from '@/components/Header/TheHeaderMobileNew.vue'

const { isDesktop } = useResponsive()
</script>

<template>
  <the-header-desktop v-if="isDesktop" />

  <the-header-mobile v-else />
</template>
